"use strict";

angular.module('rmEPG')
// .controller()
    .directive('modal', function () {

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                var $close = element.find('[close]');

                $close.on('click', function (event) {

                    event.preventDefault();
                    window.history.back();
                });
            }
        };
    });
